export default "__VITE_ASSET__DC948VYc__"